    <owl-carousel-o *ngIf="customOptionsOwl" [options]="customOptionsOwl" #carousel
        class="bar-container d-flex align-items-center justify-content-center">
        <ng-template *ngFor="let item of carouselItems; index as i" carouselSlide [id]="(i+1).toString()">
            <div class="carousel-element d-flex align-items-center justify-content-between px-4 py-5"
                [ngClass]="{'active bg-brand-95': id === (i+1).toString()}" (click)="selectItem(i + 1)">
                <div class="active-bar" [ngClass]="{show: id === (i+1).toString()}"></div>
                <p *ngIf="item.titolo" class="carousel-element__text"
                    [ngClass]="{'fw-semibold mw-100': id === (i+1).toString()}" [innerHTML]="item.titolo"></p>
                <div *ngIf="item.immagine && getImgPath(item) && id !== (i+1).toString()" class="img-container ms-4">
                    <img class="carousel-element__img" [src]="getImgPath(item)" [alt]="getTestoAlt(item)">
                </div>
            </div>
        </ng-template>
    </owl-carousel-o>